"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = exports.PaginationItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Pagination = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  gap: 6px;
`;
exports.Pagination = Pagination;
const PaginationItem = styled_components_1.default.span `
  width: 24px;
  height: 11px;
  border-radius: 35px;

  background: ${({ item }) => {
    if (!(item === null || item === void 0 ? void 0 : item.isChecked))
        return '#AEBBD2CF'; // пустой
    return (item === null || item === void 0 ? void 0 : item.isCorrect) ? '#3CB371' : '#FF4D4D'; // правильный / неправильный
}};

  border: ${({ item }) => ((item === null || item === void 0 ? void 0 : item.isChecked) ? '2px solid #fff' : '0')};

  @media (max-width: 768px) {
    width: 18px;
  }
  @media (max-width: 500px) {
    width: 14px;
  }
`;
exports.PaginationItem = PaginationItem;
//как было раньше
// const Pagination = styled.div`
//     display: flex;
//     justify-content: center;
//     gap: 6px;
// `
// interface PaginationItemProps {
//     active: boolean;
// }
// const PaginationItem = styled.span<PaginationItemProps>`
//     background: #AEBBD2CF;
//     width: 24px;
//     height: 11px;
//     border-radius: 35px;
//     background: ${(props) => props.active ? props.active : "#AEBBD2CF"};
//     border: ${(props) => props.active ? "3px solid #fff" : 0};
//     @media (max-width: 768px) {
//         width: 18px;
//     }
//     @media (max-width: 500px) {
//         width: 14px;
//     }
// `
